import LimeAPI from '../classes/LimeAPI';
import store from '../store';
import { getType } from 'typesafe-actions';
import { updateProjects } from '../store/projects/actions';
import { updateMyProjects } from '../store/myProjects/actions';
import { setProjects } from '../store/projects/actions';
import { setMyProjects } from '../store/myProjects/actions';
import { setQualityDocuments } from '../store/qualityDocuments/actions';
import { currentUserIsAdmin } from './roles';

const abortController = new AbortController();

const sortOpenProjects = (projects: any[]) =>
  projects.sort((a: any, b: any) => (a._createdtime < b._createdtime ? 1 : -1));

const sortUserOpenProjects = (projects: any[]) =>
  projects.sort((a: any, b: any) => (a.created_datetime < b.created_datetime ? 1 : -1));

export const ensureQualityDocumentsLoaded = async (signal: AbortSignal) => {
  const { qualityDocuments, currentProject } = store.getState();

  if (Array.isArray(qualityDocuments.data) && qualityDocuments.data.length > 0) {
    return;
  }

  if (!currentProject?.id) {
    return;
  }

  const response = await LimeAPI.get(`projects/${currentProject.id}/qualitydocuments`, signal);

  if (Array.isArray(response?.data)) {
    store.dispatch({
      type: getType(setQualityDocuments),
      payload: response,
    });
  }
};

export const refreshProjectLists = async (signal = abortController.signal) => {
  const { user } = store.getState();

  if (!user.identityNo || !user.id) {
    return;
  }

  const userProjectsResponse = await LimeAPI.post('projects/userProjects', {
    pin: user.identityNo,
    userId: user.id,
  }, signal);

  if (userProjectsResponse?.success && userProjectsResponse?.data) {
    const data = userProjectsResponse.data;
    sortUserOpenProjects(data.open_projects);
    sortUserOpenProjects(data.closed_projects);
    data.open_projects_count = userProjectsResponse.open_projects_count;
    data.closed_projects_count = userProjectsResponse.closed_projects_count;
    data.refreshProjects = true;

    store.dispatch({
      type: getType(setMyProjects),
      payload: data,
    });
  }

  if (!currentUserIsAdmin() || !user.company?.id) {
    return;
  }

  const allProjectsResponse = await LimeAPI.post('projects/all', {
    companyId: user.company.id,
    pin: user.identityNo,
  }, signal);

  if (allProjectsResponse?.success && allProjectsResponse?.data) {
    const data = allProjectsResponse.data;
    sortOpenProjects(data.open_projects);
    sortOpenProjects(data.closed_projects);
    data.open_projects_count = allProjectsResponse.open_projects_count;
    data.closed_projects_count = allProjectsResponse.closed_projects_count;
    data.refreshProjects = true;

    store.dispatch({
      type: getType(setProjects),
      payload: data,
    });
  }
};

export const setProjectStatus = async (projectstatus: string, status_tiler: string): Promise<boolean> => {
  const { id, company } = store.getState().currentProject;

  const payload = {
    projectstatus,
    status_tiler,
    company,
  };

  const response = await LimeAPI.put(`projects/${id}`, payload, abortController.signal);

  if (!response?.success || !response?.data?.projectstatus) {
    return false;
  }

  const storePayload = {
    _id: id,
    projectstatus: response.data.projectstatus,
    status_tiler: response.data.status_tiler,
  };

  if (currentUserIsAdmin()) {
    store.dispatch({
      type: getType(updateProjects),
      payload: storePayload,
    });
  }

  store.dispatch({
    type: getType(updateMyProjects),
    payload: storePayload,
  });

  return true;
};

const getDocumentStatusKey = (document: any) => {
  const status = document?.qualitydocumentstatus;

  if (status == null) {
    return undefined;
  }

  if (typeof status === 'string') {
    return status;
  }

  return status.key;
};

const getDocumentStatuses = () => {
  const documents = store.getState().qualityDocuments.data || [];

  if (!Array.isArray(documents)) {
    return [];
  }

  return documents
    .map(getDocumentStatusKey)
    .filter((status: any) => status);
};

const getLowestDocumentStatus = (statuses: string[]) => {
  const sortOrder = [
    'markasdone',
    'open',
    'approved',
  ];

  return statuses.sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b))[0];
};

export const getNewProjectStatus = () => {
  const lowestStatus = getLowestDocumentStatus(getDocumentStatuses());
  const statusMap: any = {
    open: {
      'status_tiler': 'actionrequired',
      'projectstatus': 'open',
    },
    markasdone: {
      'projectstatus': 'actionrequired',
      'status_tiler': 'open',
    },
    approved: {
      'projectstatus': 'approved',
      'status_tiler': 'approved',
    },
  };

  if (!lowestStatus || !statusMap[lowestStatus]) {
    return undefined;
  }

  return statusMap[lowestStatus];
};

export const isProjectFinished = (project: any) => project.status.key === 'finished';
export const currentUserIsTiler = () => store.getState().currentQualityDocument.persontiler._id === store.getState().user.id;
export const userExistsInProject = () => Object.values(store.getState().currentProject.persons).flat().filter((person: any) => person.personId === store.getState().user.id).length > 0;
